import Modal from '@components/Modal'
import React from 'react'
import { ModalMessage } from './ProfilePage.styles'

interface EditProfilePictureModalProps {
	isOpen: boolean
	onClose: () => void
}

const EditProfilePictureModal: React.FC<EditProfilePictureModalProps> = ({ isOpen, onClose }) => {
	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			title="Edit Profile Picture"
			showCloseButton={true}
			size="medium"
		>
			<ModalMessage>You must set your profile picture inside the iOS/Android app</ModalMessage>
		</Modal>
	)
}

export default EditProfilePictureModal

